
export default function ProjectsHero() {
  return (
    <section className="pt-20 sm:pt-24 lg:pt-32 pb-16 sm:pb-20 lg:pb-24 bg-gray-900 text-white">
      <div className="px-4 sm:px-6 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold mb-4 sm:mb-6 leading-tight">
            Our Projects
          </h1>
          <p className="text-lg sm:text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto">
            From single-room extensions to complete property transformations, 
            explore how we've helped homeowners across Buckinghamshire create 
            their perfect living spaces.
          </p>
        </div>
      </div>
    </section>
  );
}
